const PURCHASE_OPTION_BY_PLAN_TYPE = {
  MONTHLY: 'monthly',
  ANNUAL: 'annually'
}

const googleAdsService = {

  recordEvent: ({ eventDetails }) => {
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(eventDetails)
    }
  },

  recordAddToCartEvent: ({ email, phone }) => {
    googleAdsService.recordEvent({
      eventDetails: {
        event: 'add_to_cart',
        email,
        telephone: phone
      }
    })
  },

  recordPurchaseEvent: ({ planType }) => {
    googleAdsService.recordEvent({
      eventDetails: {
        event: 'purchase',
        purchase_option: PURCHASE_OPTION_BY_PLAN_TYPE[planType]
      }
    })
  }
}

export default googleAdsService
